var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.7035V4.69059C3 4.53779 3.11485 4.4094 3.26671 4.39244L4.39292 4.26669C6.3544 4.04767 8.23437 3.35985 9.87407 2.26132L11.5898 1.11187C11.6908 1.04418 11.8227 1.04418 11.9237 1.11187L13.5796 2.22122C15.2574 3.34532 17.1863 4.03897 19.1958 4.24091L20.73 4.39509C20.8833 4.41049 21 4.53952 21 4.69359V12.5707C21 15.4119 19.5466 18.0558 17.1478 19.5783L11.9219 22.8952C11.8216 22.9589 11.693 22.9573 11.5942 22.8911L6.68028 19.599C4.3803 18.0581 3 15.4719 3 12.7035Z",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5534 8.92961V8.31622C10.5534 8.30831 10.5532 8.30158 10.5527 8.29368C10.5441 8.14537 10.482 6.5 12 6.5C13.5051 6.5 13.3975 8.19252 13.3818 8.37258C13.3809 8.38358 13.3804 8.39357 13.3804 8.40462V8.92961M10.5534 8.92961C11.4908 8.6542 12.4349 8.73326 13.3804 8.92961M10.5534 8.92961C8.13487 9.64026 8.66667 11.4744 8.66667 13.087C8.66667 13.5857 8.11829 14.2276 7.65064 14.6843C7.4466 14.8835 7.58491 15.2609 7.8701 15.2609H12H16.1299C16.4151 15.2609 16.5534 14.8835 16.3494 14.6843C15.8817 14.2276 15.3333 13.5857 15.3333 13.087C15.3333 11.604 15.867 9.44608 13.3804 8.92961M10.8889 17H13.1111",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityAlarm);
export default __webpack_public_path__ + "static/media/security_alarm.aa33e9afaa647f50e0ee6fef894617cf.svg";
export { ForwardRef as ReactComponent };